import Sticky from "./Sticky";
import Container from "./Container";

export { Sticky };
export { Container as StickyContainer };
export default Sticky;